'use client'
import { tw } from '@/lib/utils'

// A band card's placeholder while the deferred nav loads: the lead card's
// picture-over-copy shape, or the small card's thumbnail beside two lines.
export const SheetSkeletonCard = ({ small = false }: { small?: boolean }) => (
  <div
    aria-hidden
    className={tw(
      'flex h-full border border-(--sh-card-border) bg-(--sh-card) p-3',
      small ? 'gap-4 rounded-2xl' : 'flex-col rounded-3xl'
    )}
  >
    <div
      className={tw(
        'aspect-16/10 animate-pulse bg-(--sh-skeleton)',
        small ? 'w-[7rem] shrink-0 rounded-xl' : 'rounded-2xl'
      )}
    />
    <div className={tw('flex flex-1 flex-col gap-2', small ? 'py-0.5' : 'px-2 pt-4 pb-2')}>
      <div className={tw('animate-pulse rounded bg-(--sh-skeleton)', small ? 'h-3 w-1/4' : 'h-5 w-4/5')} />
      <div className={tw('animate-pulse rounded bg-(--sh-skeleton)', small ? 'h-4 w-4/5' : 'h-5 w-3/5')} />
      <div className={tw('animate-pulse rounded bg-(--sh-skeleton)', small ? 'h-4 w-3/5' : 'mt-2 h-3.5 w-2/5')} />
    </div>
  </div>
)
